import { render, staticRenderFns } from "./index.vue?vue&type=template&id=254079c6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('254079c6')) {
      api.createRecord('254079c6', component.options)
    } else {
      api.reload('254079c6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=254079c6", function () {
      api.rerender('254079c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/SideMenu/index.vue"
export default component.exports